import React, {useContext} from 'react';

import Grid from "@material-ui/core/Grid";
import AppButton from "../../../Common/AppButton";
import useStyles from "./styles";
import PriorAuthorizationContext from "../../../../contexts/PriorAuthorization/PriorAuthorization.context";

export default function FormFooter(props) {
   const {handleCancel, ...wrapperProps} = props
   const classes = useStyles();
   const { setModalState, create:{currentStep, steps, nextStep, prevStep} } = useContext(PriorAuthorizationContext);

   if (!steps || !steps[currentStep]) return <></>;

   const isNextDisabled = () => steps[currentStep].hasNext ? !steps[currentStep].isValid : true
   const isBackDisabled = () => currentStep === 0

   const confirmAttestation = async () => {
      setModalState({open: false, isBlocking: false})
      nextStep();
   }

   const cancelAttestModal = () => {
      setModalState({open: false})
   }
   const openAttestationModal = () => {
      setModalState({
         confirm: confirmAttestation,
         confirmText: 'YES, I attest',
         confirmToolTip:  'Confirm Cancel',
         deny: cancelAttestModal,
         denyText: 'No, Go Back',
         denyToolTip: 'Go Back',
         open: true,
         title: 'I attest the information provided is true and accurate to the best of my knowledge. I understand that Medi-Cal Rx or its designees may perform a routine audit and request the medical information necessary to verify the accuracy of the information reported on this form.'
      });
   }

   const genericProps = {
      disableTooltip: true,
      size: 'large',
      buttonStyle: {minWidth: '115px', maxWidth: '115px'},
   }

   return (
      <div id='MEDCAL_RX_CREATE_PA_FORM_FOOTER' {...wrapperProps} >
         <Grid container spacing={1} className={classes.stepperActions}>
            <Grid container item style={{maxWidth: 'fit-content'}} >
               <AppButton
                  className='btn-primary'
                  disabled={isBackDisabled()}
                  id='MEDCAL_RX_CREATE_PA_BACK'
                  text='Previous'
                  onClick={ prevStep }
                  buttonProps={{'data-testid': 'MEDCAL_RX_CREATE_PA_BACK'}}
                  {...genericProps}
               />
            </Grid>
            <Grid container item style={{maxWidth: 'fit-content'}} >
               <AppButton
                    id='MEDCAL_RX_CREATE_PA_CANCEL'
                  text='Cancel'
                  onClick={ handleCancel }
                  variant={'outlined'}
                  buttonProps={{'data-testid': 'MEDCAL_RX_CREATE_PA_CANCEL'}}
                  {...genericProps}
               />
            </Grid>
            {currentStep < steps.length - 1 &&
            <Grid container item style={{maxWidth: 'fit-content'}} >
               <AppButton
                  className='btn-primary'
                  id='MEDCAL_RX_CREATE_PA_NEXT'
                  text="next"
                  disabled={ isNextDisabled() }
                  onClick={ nextStep }
                  buttonProps={{'data-testid': 'MEDCAL_RX_CREATE_PA_NEXT'}}
                  {...genericProps}
               />
            </Grid>}
            {currentStep === steps.length - 1 &&
            <Grid container item style={{maxWidth: 'fit-content'}} >
               <AppButton
                  className='btn-primary'
                  id='MEDCAL_RX_CREATE_PA_NEXT'
                  text="SUBMIT"
                  onClick={ openAttestationModal }
                  buttonProps={{'data-testid': 'MEDCAL_RX_CREATE_PA_NEXT'}}
                  {...genericProps}
               />
            </Grid>}
         </Grid>
      </div>
   )
};
